import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type GeneralReportFooterProps = {
  isLastStep?: boolean;
  disabled?: boolean;
};

const GeneralReportFooter: React.FunctionComponent<
  GeneralReportFooterProps
> = ({ isLastStep, disabled }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCancelClick = () => {
    navigate("/polestar");
  };

  return (
    <>
      <footer className="flex gap-4 p-6 border-t border-gray-200">
        {!isLastStep && (
          <button type="submit" className="btn-primary" disabled={disabled}>
            {t("common.continue")}
          </button>
        )}
        <button className="btn-outline-primary" onClick={handleCancelClick}>
          {t("common.cancel")}
        </button>
      </footer>
    </>
  );
};

export default GeneralReportFooter;
